import React from 'react';
import {formatToPersianAddComma, parseToEnRemoveComma} from "../../../utils/CommaSeparator";
import numericFunction from "../../../utils/NumericFunction";

function HeaderPrintSellFactor({title, data, totlaPage, currentPage}) {

  const shopName = data?.headerAndFooter?.header?.find(v => v.id === "Memo10")?.value
  const factorNumber = data?.headerAndFooter?.header?.find(v => v.id === "Memo60")
  const date = data?.headerAndFooter?.header?.find(v => v.id === "Memo69")
  return (<div>

    <div className={"text-center fw-bold my-2 rtl"}>{title}</div>
    <div
      className={"py-3 px-3 mb-1 border9BA5B7 rtl"}
    >
      <div className={'d-flex justify-content-between rtl'}>
        <div>{shopName}</div>
        <div> شماره صفحه:
          {formatToPersianAddComma(currentPage)}
          &nbsp; از  &nbsp;
          {formatToPersianAddComma(totlaPage)}
        </div>
      </div>
      <div className={'d-flex justify-content-between mt-2'}>
        <div>{factorNumber?.label} : {factorNumber?.value}</div>
        <div>
          {date.label}:{numericFunction.e2p(date.value)}
        </div>
      </div>

    </div>


  </div>);
}

export default HeaderPrintSellFactor;